<template>
    <div :class="$style['search-title']">
        <h1 :class="[$style['search-title__text'], 'sw-title']">
            {{ $t('search_title_desktop') }}
        </h1>

        <h4
            v-if="count === 0"
            :class="[
                $style['search-title__no-results-mobile'],
                $style['d-inline-block-mobile'],
                'sw-title'
            ]"
        >
            {{ $t('search_noresults_mobile') }}
        </h4>

        <h3
            v-if="query"
            :class="[$style['search-title__query-string'], 'sw-title']"
        >
            «{{ query }}»
        </h3>

        <h5
            v-if="count > 0"
            :class="[$style['search-title__results'], 'sw-title']"
        >
            {{ $t('search_results') }}
            {{ count }}
            {{ count === 1 ? $t('search_results_count') : $t('search_results_counts') }}
        </h5>

        <h5
            v-else
            :class="[
                $style['search-title__results'],
                $style['d-inline-block-desktop'],
                'sw-title'
            ]"
        >
            {{ $t('search_noresults') }}
        </h5>
    </div>
</template>

<script>
export default {
  name: 'SearchTitle',

  props: {
    query: {
      type: String,
      default: ''
    },

    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="less" module>
@import (reference) "~@omnica/base/assets/stylesheets/variables.less";
@import (reference) "./assets/Web.less";

.search-title {
  display: flex;
  flex-direction: column;

  &__query-string {
    margin: 0 !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    word-break: break-word;
    @media screen and (min-width: @bp-tablet) {
      font-size: 32px !important;
      line-height: 40px !important;
    }
  }

  h1&__text {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    @media screen and (max-width: @bp-tablet) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  &__no-results-mobile {
    font-weight: normal !important;
    margin: 0 0 8px 0 !important;
  }

  &__results {
    font-size: 16px;
    line-height: 24px !important;
    color: @grey-800;
    margin: 8px 0 40px !important;
    @media screen and (max-width: @bp-tablet) {
      font-size: 14px;
      line-height: 20px !important;
      margin: 8px 0 24px !important;
    }
  }
}

.d-inline-block-desktop {
  display: inline-block;
  @media screen and (max-width: @bp-tablet) {
    display: none;
  }
}

.d-inline-block-mobile {
  display: none;
  @media screen and (max-width: @bp-tablet) {
    display: inline-block;
  }
}
</style>
